import { isEmpty } from 'lodash';
import tmsApi from './../api/tmsApi';
import helper from './helper';

const { createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    dataState: {
      shipment_preset: 'LOADING',
    },
    shipment_presets: {},
    detailData: null,
    detailDataId: null,
    dataLoaded: false,
    count_info: {
      all: 0,
      default: 0,
      transporter: 0,
      customer: 0,
      active: 0,
      inactive: 0,
    },
    query: {
      search: '',
      page: {
        number: 1,
        count: 10,
      },
      sort: {
        by: 'NAME',
        direction: 'ASC',
      },
      type: null,
      active: 'all',
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.shipment_preset.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.shipment_preset.push(data);
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.page.number = 1;
      query.page.count = 10;
      query.sort.by = 'NAME';
      query.sort.direction = 'ASC';
      query.type = null;
      query.active = 'all';
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count = 10) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_QUERY_TYPE(state, type) {
      state.query.type = type;
    },
    SET_QUERY_ACTIVE(state, active) {
      state.query.active = active;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      state.count_info.default = 0;
      state.count_info.transporter = 0;
      state.count_info.customer = 0;
      state.count_info.active = 0;
      state.count_info.inactive = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
        if (c.type === 'DEFAULT') {
          state.count_info.default += c.count;
        } else if (c.type === 'TRANSPORTER') {
          state.count_info.transporter += c.count;
        } else if (c.type === 'CUSTOMER') {
          state.count_info.customer += c.count;
        }
        if (c.active) {
          state.count_info.active += c.count;
        } else {
          state.count_info.inactive += c.count;
        }
      }, this);
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.shipment_preset.findIndex(cmp => cmp.id === id);
      state.shipment_preset.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_COMPANIES({ dataState }, state) {
      dataState.shipment_preset = state;
    },
  },
  getters: {
    shipment_preset(state) {
      return state.shipment_preset;
    },
    usershipment_preset(state, getters, rootState) {
      const userData = rootState.userData || {};
      const shipment_preset = userData.shipment_preset || {};

      return shipment_preset;
    },
    transporters(state, getters) {
      const transporterIds = getters.usershipment_preset._transporterIds || []; // eslint-disable-line

      return state.shipment_preset
        .filter(c => transporterIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    customers(state, getters) {
      const customerIds = getters.usershipment_preset._customerIds || []; // eslint-disable-line

      return state.shipment_preset
        .filter(c => customerIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    tenants(state, getters) {
      const tenantIds = getters.usershipment_preset._tenantIds || []; // eslint-disable-line

      return state.shipment_preset
        .filter(c => tenantIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    providers(state, getters) {
      const providerIds = getters.usershipment_preset._providerIds || []; // eslint-disable-line

      return state.shipment_preset
        .filter(c => providerIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    tenant_customers(state, getters) {
      const tenantCustomerIds = getters.usershipment_preset._tenantCustomerIds || []; // eslint-disable-line

      return state.shipment_preset
        .filter(c => tenantCustomerIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    count_all(state) {
      return state.count_info.all;
    },
    count_default(state) {
      return state.count_info.default;
    },
    count_transporter(state) {
      return state.count_info.transporter;
    },
    count_customer(state) {
      return state.count_info.customer;
    },
    count_active(state) {
      return state.count_info.active;
    },
    count_inactive(state) {
      return state.count_info.inactive;
    },
    query_count(state) {
      return state.query.page.count;
    },
    query_page(state) {
      return state.query.page.number;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    dataStateCompanies(state) {
      return state.dataState.shipment_preset;
    },
  },
  actions: {
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          shipment_presets(company_id: ${state.detailDataId}) {
            id
            preset_name
            config
          }
        }
      `;
      return api(query, 'shipment_preset').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.shipment_presets);
      }).catch(() => {
        commit('SET_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    CREATE_DATA({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);
      const company_id = createInputParam(payloads.sign_load_sheet.start, 'company_id');
      const conf = payloads.sign_load_sheet.start;
      let config = '';
      if (!isEmpty(conf)) {
        const drivers = conf.driver;
        const loaders1 = conf.loader1;
        const loaders2 = conf.loader2;
        const locations = conf.location;
        const active_loader2 = createInputParam(loaders2, 'active_loader2');
        const fill_name2 = createInputParam(loaders2, 'fill_name2');
        const method2 = createInputParam(loaders2, 'method2');
        const terms2 = createInputParam(loaders2, 'terms2');
        const active_loader = createInputParam(loaders1, 'active_loader');
        const fill_name = createInputParam(loaders1, 'fill_name');
        const method = createInputParam(loaders1, 'method');
        const terms = createInputParam(loaders1, 'terms');
        const address = createInputParam(locations, 'address');
        const code = createInputParam(locations, 'code');
        const name = createInputParam(locations, 'name');
        const fill_name_driver = createInputParam(drivers, 'fill_name_driver');
        const method_driver = createInputParam(drivers, 'method_driver');
        const terms_driver = createInputParam(drivers, 'terms_driver');
        const confirmType = createInputParam(conf, 'confirmType');
        const driverConfirm = createInputParam(conf, 'driverConfirm');
        const sortOrder = createInputParam(conf, 'sortOrder');
        const driverFinishManifest = createInputParam(conf, 'driverFinishManifest');
        config = `config: {
          ${confirmType}
          ${driverConfirm}
          ${sortOrder}
          ${driverFinishManifest}
          driver: {
            ${fill_name_driver}
            ${method_driver}
            ${terms_driver}
          }
          loader1: {
            ${active_loader}
            ${fill_name}
            ${method}
            ${terms}
          }
          loader2: {
            ${active_loader2}
            ${fill_name2}
            ${method2}
            ${terms2}
          }
          location: {
            ${address}
            ${code}
            ${name}
          }
        }`;
      }

      const mutation = `mutation {
        CreateShipmentPreset: create_shipment_preset(input: {
          ${company_id},
          preset_name: "Capral Preset",
          ${config}
        }) {
          id
          config
          preset_name
          company {
            id
          }
        }
      }`;

      return api(mutation, 'create_shipment_preset').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.shipment_preset);
        return data.shipment_preset;
      }).catch(() => {
        commit('SET_ERROR', 'CREATE_DATA');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/shipment_preset.js